import { createValidator, rules } from "@lchemy/model/validation";

import { UserStatus } from "../enums";
import { User } from "../user";

export interface InsertUserCmd extends User {
  sendEmail: boolean;
}

export const insertUserCmdValidator = createValidator<InsertUserCmd>({
  email: [rules.required(), rules.isString(), rules.isEmail()],
  name: [rules.required(), rules.isString(), rules.minLength(1)],
  status: [
    rules.required(),
    rules.isString(),
    rules.isIn(Object.keys(UserStatus))
  ],
  sendEmail: [rules.required(), rules.isBoolean()]
});
